import * as types from '../service/actionTypes';

export default function pastOrderState(state = {
                                         pastOrderData: {},
                                         selectedpastnumber: 90
                                     },
                                     action) {
    switch (action.type) {
        case types.PAST_ORDER_DATA:
            return {
                ...state,
                pastOrderData: action.pastOrderData
            }
        case types.SELECTED_PAST_NUMBER:
            return {
                ...state,
                selectedpastnumber: action.selectedpastnumber
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/pastOrderReducer.js